import { useState } from 'react';
import { Flame } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DishImageProps {
  src: string;
  alt: string;
  className?: string;
}

/**
 * Dish photo with a graceful branded fallback — if the remote image fails
 * to load, an ember-gradient tile with a flame mark is shown instead.
 */
export function DishImage({ src, alt, className }: DishImageProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className={cn(
          'flex items-center justify-center bg-gradient-to-br from-ember via-primary to-marigold',
          className,
        )}
        role="img"
        aria-label={alt}
      >
        <Flame className="size-8 text-white/80" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className={cn('object-cover', className)}
    />
  );
}
